import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from "@angular/core";
import { GenericPaginationListConfig } from "@app/shared/models/GenericPaginationList/GenericPaginationListConfig";
import { CerrixAddAndFilterBarComponent } from "@app/shared/molecules/cerrix-add-and-filter-bar/cerrix-add-and-filter-bar.component";
import { SharedModule } from "@app/shared/shared.module";

@Component({
  selector: "cerrix-filtered-generic-list-manager",
  imports: [CerrixAddAndFilterBarComponent, SharedModule],
  templateUrl: "./cerrix-filtered-generic-list-manager.component.html",
  styleUrls: ["./cerrix-filtered-generic-list-manager.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CerrixFilteredGenericListManagerComponent implements OnInit {
  @Input() config: GenericPaginationListConfig;
  @Output() addButtonClicked: EventEmitter<void> = new EventEmitter();

  data?: any[];
  filteredData: any[] = [];
  scopedTableData: any[] = [];
  scopedTableExpanded = false;
  scopedToggleAllowed = false;

  constructor() {}

  ngOnInit() {
    this.data = this.config.data;
  }

  public search(searchInput?: string) {
    this.searchTableData(searchInput);
    this.updateConfig();
  }

  private updateConfig() {
    this.config.data = this.scopedTableData;
    this.config.reload();
  }

  toggleScopedTableData() {
    this.scopedTableExpanded = !this.scopedTableExpanded;
    this.setScopedTable();
  }

  setScopedTable() {
    this.scopedToggleAllowed =
      this.config.limitViewTo > 0 &&
      !this.config.isSortable &&
      this.filteredData.length > this.config.limitViewTo;

    if (this.scopedToggleAllowed && !this.scopedTableExpanded) {
      this.scopedTableData = this.filteredData.slice(
        0,
        this.config.limitViewTo,
      );
    } else {
      this.scopedTableData = this.filteredData;
    }

    this.config._visibleRowCount = this.filteredData.length;
  }

  private searchTableData(terms: string) {
    terms = terms.trim();

    if (terms.length === 0) {
      this.filteredData = this.data;
    } else if (this.data && this.data.length > 0) {
      this.filteredData = [];
      const searchTerms = terms
        .split(" ")
        .filter((t) => t.trim().length > 0)
        .map((t) => t.toLowerCase());

      const properties = Object.getOwnPropertyNames(this.data[0]);
      this.data.forEach((row) => {
        const rowText = properties
          .map((p) => row[p])
          .join("")
          .toLowerCase();
        const rowMatched = searchTerms.some((st) => rowText.indexOf(st) >= 0);

        if (rowMatched) {
          this.filteredData.push(row);
        }
      });
    }

    this.setScopedTable();
  }
}
